<template>
  <div v-loading="isLoading" style="height: 100%;overflow: auto;">
    <el-button size="mini" @click="back">返回</el-button>
    <el-button type="primary" size="mini" @click="submit">提交</el-button>
    <el-input
      type="textarea"
      :rows="30"
      placeholder="请输入配置"
      v-model="basicConfig.config">
    </el-input>
  </div>
</template>

<script>
  import util from '@/libs/util'
  export default {
    name: 'set-analyse-config-detail',
    data() {
      return {
        basicConfig: {
          id: this.$route.query.parentId
        },
        isLoading: false
      }
    },
    mounted() {
      this.loadConfig()
    },
    methods: {
      loadConfig: function () {
        this.isLoading = true
        util.ajax.get('/superAdmin/analyse/setAnalyseConfigDetail/config/' + this.basicConfig.id).then(res => {
          if (res.data.meta && res.data.meta.errCode === 0) {
            this.basicConfig = res.data.data
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.message})
          }
          this.isLoading = false
        }).catch(err => {
          console.error(err)
          this.isLoading = false
          this.$notify.error({title: '错误', message: '系统错误'})
        })
      },
      back: function () {
        util.routerBack(this)
      },
      submit: function () {
        this.isLoading = true
        util.ajax.post('/superAdmin/analyse/setAnalyseConfigDetail/config', {
          params: this.basicConfig
        }).then(res => {
          if (res.data.meta && res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '保存成功'})
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.message})
          }
          this.isLoading = false
        }).catch(err => {
          console.error(err)
          this.isLoading = false
          this.$notify.error({title: '错误', message: '系统错误'})
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/config/set-analyse-config-detail.vue